/**
 * @author Jonathan C. Muniz
 * @version $Id$
 */
export class Filter {

  /*type - name; line*/
  public type: string;
  public value: string;

  public constructor() {

  }
}


// WEBPACK FOOTER //
// ./src/app/models/filter.model.ts